"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowsServiceServer = exports.FlowsServiceDispatcher = exports.FlowsServiceClient = void 0;
var QueryFlowsResponse_1 = require("./QueryFlowsResponse");
var services_shared_1 = require("@playq/services-shared");
var FlowWithVersion_1 = require("./FlowWithVersion");
var MissingFlows_1 = require("./MissingFlows");
var octopus2_apps_1 = require("@playq/octopus2-apps");
var FlowsSort_1 = require("./FlowsSort");
var octopus_notifications_1 = require("@playq/octopus-notifications");
var octopus_common_1 = require("@playq/octopus-common");
var AppFlow_1 = require("./AppFlow");
var FlowsDemotionResponse_1 = require("./FlowsDemotionResponse");
var AppFlowResponse_1 = require("./AppFlowResponse");
var FlowCreateData_1 = require("./FlowCreateData");
var FlowsPromotionsResponse_1 = require("./FlowsPromotionsResponse");
var irt_1 = require("@playq/irt");
var InCreate = (function () {
    function InCreate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new octopus_common_1.AppID(data.app);
        this.data = new FlowCreateData_1.FlowCreateData(data.data);
    }
    Object.defineProperty(InCreate.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreate.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field data is not optional');
            }
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreate.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            data: this.data.serialize()
        };
    };
    return InCreate;
}());
var OutCreateHelpers = (function () {
    function OutCreateHelpers() {
    }
    OutCreateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCreateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new AppFlow_1.AppFlow(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateHelpers;
}());
var InRetrieve = (function () {
    function InRetrieve(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.version = typeof data.version !== 'undefined' ? data.version : undefined;
    }
    Object.defineProperty(InRetrieve.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieve.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._version = undefined;
                return;
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieve.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: typeof this.version !== 'undefined' ? this.version : undefined
        };
    };
    return InRetrieve;
}());
var OutRetrieveHelpers = (function () {
    function OutRetrieveHelpers() {
    }
    OutRetrieveHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new AppFlowResponse_1.AppFlowResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveHelpers;
}());
var InUpdate = (function () {
    function InUpdate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.data = new FlowCreateData_1.FlowCreateData(data.data);
        this.version = typeof data.version !== 'undefined' ? data.version : undefined;
    }
    Object.defineProperty(InUpdate.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdate.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field data is not optional');
            }
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdate.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._version = undefined;
                return;
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdate.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            data: this.data.serialize(),
            version: typeof this.version !== 'undefined' ? this.version : undefined
        };
    };
    return InUpdate;
}());
var OutUpdateHelpers = (function () {
    function OutUpdateHelpers() {
    }
    OutUpdateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateHelpers;
}());
var InDelete = (function () {
    function InDelete(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
    }
    Object.defineProperty(InDelete.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InDelete.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InDelete;
}());
var OutDeleteHelpers = (function () {
    function OutDeleteHelpers() {
    }
    OutDeleteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteHelpers;
}());
var InQueryVersions = (function () {
    function InQueryVersions(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new octopus2_apps_1.AppEntitySort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.features = data.features.map(function (e) { return octopus2_apps_1.AppEntityFeatures[e]; });
    }
    Object.defineProperty(InQueryVersions.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryVersions.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryVersions.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryVersions.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryVersions.prototype, "features", {
        get: function () {
            return this._features;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field features is not optional');
            }
            this._features = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryVersions.prototype.serialize = function () {
        var _this = this;
        return {
            id: this.id.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            features: this.features.map(function (e) { return octopus2_apps_1.AppEntityFeatures[e]; })
        };
    };
    return InQueryVersions;
}());
var OutQueryVersionsHelpers = (function () {
    function OutQueryVersionsHelpers() {
    }
    OutQueryVersionsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryVersionsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus2_apps_1.AppEntitiesResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryVersionsHelpers;
}());
var InQueryFlows = (function () {
    function InQueryFlows(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new octopus_common_1.AppID(data.app);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new FlowsSort_1.FlowsSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryFlows.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFlows.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFlows.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFlows.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryFlows.prototype.serialize = function () {
        var _this = this;
        return {
            app: this.app.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryFlows;
}());
var OutQueryFlowsHelpers = (function () {
    function OutQueryFlowsHelpers() {
    }
    OutQueryFlowsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryFlowsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new QueryFlowsResponse_1.QueryFlowsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryFlowsHelpers;
}());
var InCheckFlows = (function () {
    function InCheckFlows(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.flows = data.flows.map(function (e) { return new octopus_common_1.FlowID(e); });
    }
    Object.defineProperty(InCheckFlows.prototype, "flows", {
        get: function () {
            return this._flows;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flows is not optional');
            }
            this._flows = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckFlows.prototype.serialize = function () {
        return {
            flows: this.flows.map(function (e) { return e.serialize(); })
        };
    };
    return InCheckFlows;
}());
var OutCheckFlowsHelpers = (function () {
    function OutCheckFlowsHelpers() {
    }
    OutCheckFlowsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCheckFlowsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new MissingFlows_1.MissingFlows(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCheckFlowsHelpers;
}());
var InQueryPromotions = (function () {
    function InQueryPromotions(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.features = data.features.map(function (e) { return octopus_common_1.PromotionFeatures[e]; });
    }
    Object.defineProperty(InQueryPromotions.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryPromotions.prototype, "features", {
        get: function () {
            return this._features;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field features is not optional');
            }
            this._features = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryPromotions.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            features: this.features.map(function (e) { return octopus_common_1.PromotionFeatures[e]; })
        };
    };
    return InQueryPromotions;
}());
var OutQueryPromotionsHelpers = (function () {
    function OutQueryPromotionsHelpers() {
    }
    OutQueryPromotionsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryPromotionsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_common_1.EntityPromotionsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryPromotionsHelpers;
}());
var InPromote = (function () {
    function InPromote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.version = data.version;
        this.env = octopus_common_1.Environment[data.env];
        this.space = typeof data.space !== 'undefined' ? new octopus_common_1.SpaceID(data.space) : undefined;
    }
    Object.defineProperty(InPromote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromote.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromote.prototype, "space", {
        get: function () {
            return this._space;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._space = undefined;
                return;
            }
            this._space = value;
        },
        enumerable: false,
        configurable: true
    });
    InPromote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: this.version,
            env: octopus_common_1.Environment[this.env],
            space: typeof this.space !== 'undefined' ? this.space.serialize() : undefined
        };
    };
    return InPromote;
}());
var OutPromoteHelpers = (function () {
    function OutPromoteHelpers() {
    }
    OutPromoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutPromoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_common_1.Promotion(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPromoteHelpers;
}());
var InDemote = (function () {
    function InDemote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new octopus_common_1.FlowID(data.id);
        this.version = data.version;
        this.env = octopus_common_1.Environment[data.env];
        this.space = typeof data.space !== 'undefined' ? new octopus_common_1.SpaceID(data.space) : undefined;
    }
    Object.defineProperty(InDemote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemote.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemote.prototype, "space", {
        get: function () {
            return this._space;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._space = undefined;
                return;
            }
            this._space = value;
        },
        enumerable: false,
        configurable: true
    });
    InDemote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: this.version,
            env: octopus_common_1.Environment[this.env],
            space: typeof this.space !== 'undefined' ? this.space.serialize() : undefined
        };
    };
    return InDemote;
}());
var OutDemoteHelpers = (function () {
    function OutDemoteHelpers() {
    }
    OutDemoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDemoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDemoteHelpers;
}());
var InQueryPromotionsBatch = (function () {
    function InQueryPromotionsBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new octopus_common_1.FlowID(e); });
        this.features = data.features.map(function (e) { return octopus_common_1.PromotionFeatures[e]; });
    }
    Object.defineProperty(InQueryPromotionsBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryPromotionsBatch.prototype, "features", {
        get: function () {
            return this._features;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field features is not optional');
            }
            this._features = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryPromotionsBatch.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); }),
            features: this.features.map(function (e) { return octopus_common_1.PromotionFeatures[e]; })
        };
    };
    return InQueryPromotionsBatch;
}());
var OutQueryPromotionsBatchHelpers = (function () {
    function OutQueryPromotionsBatchHelpers() {
    }
    OutQueryPromotionsBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryPromotionsBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new FlowsPromotionsResponse_1.FlowsPromotionsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryPromotionsBatchHelpers;
}());
var InPromoteBatch = (function () {
    function InPromoteBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.batch = data.batch.map(function (e) { return new FlowWithVersion_1.FlowWithVersion(e); });
        this.env = octopus_common_1.Environment[data.env];
        this.space = typeof data.space !== 'undefined' ? new octopus_common_1.SpaceID(data.space) : undefined;
    }
    Object.defineProperty(InPromoteBatch.prototype, "batch", {
        get: function () {
            return this._batch;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field batch is not optional');
            }
            this._batch = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromoteBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromoteBatch.prototype, "space", {
        get: function () {
            return this._space;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._space = undefined;
                return;
            }
            this._space = value;
        },
        enumerable: false,
        configurable: true
    });
    InPromoteBatch.prototype.serialize = function () {
        return {
            batch: this.batch.map(function (e) { return e.serialize(); }),
            env: octopus_common_1.Environment[this.env],
            space: typeof this.space !== 'undefined' ? this.space.serialize() : undefined
        };
    };
    return InPromoteBatch;
}());
var OutPromoteBatchHelpers = (function () {
    function OutPromoteBatchHelpers() {
    }
    OutPromoteBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutPromoteBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPromoteBatchHelpers;
}());
var InDemoteBatch = (function () {
    function InDemoteBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.batch = data.batch.map(function (e) { return new FlowWithVersion_1.FlowWithVersion(e); });
        this.env = octopus_common_1.Environment[data.env];
        this.space = typeof data.space !== 'undefined' ? new octopus_common_1.SpaceID(data.space) : undefined;
    }
    Object.defineProperty(InDemoteBatch.prototype, "batch", {
        get: function () {
            return this._batch;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field batch is not optional');
            }
            this._batch = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemoteBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemoteBatch.prototype, "space", {
        get: function () {
            return this._space;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._space = undefined;
                return;
            }
            this._space = value;
        },
        enumerable: false,
        configurable: true
    });
    InDemoteBatch.prototype.serialize = function () {
        return {
            batch: this.batch.map(function (e) { return e.serialize(); }),
            env: octopus_common_1.Environment[this.env],
            space: typeof this.space !== 'undefined' ? this.space.serialize() : undefined
        };
    };
    return InDemoteBatch;
}());
var OutDemoteBatchHelpers = (function () {
    function OutDemoteBatchHelpers() {
    }
    OutDemoteBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDemoteBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new FlowsDemotionResponse_1.FlowsDemotionResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDemoteBatchHelpers;
}());
var InQueryNotifications = (function () {
    function InQueryNotifications(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.flow = typeof data.flow !== 'undefined' ? new octopus_common_1.FlowID(data.flow) : undefined;
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new octopus_notifications_1.NotificationsSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryNotifications.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "flow", {
        get: function () {
            return this._flow;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._flow = undefined;
                return;
            }
            this._flow = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryNotifications.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryNotifications.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            flow: typeof this.flow !== 'undefined' ? this.flow.serialize() : undefined,
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryNotifications;
}());
var OutQueryNotificationsHelpers = (function () {
    function OutQueryNotificationsHelpers() {
    }
    OutQueryNotificationsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryNotificationsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_notifications_1.NotificationsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryNotificationsHelpers;
}());
var InGetAnnotations = (function () {
    function InGetAnnotations(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.flow = new octopus_common_1.FlowID(data.flow);
    }
    Object.defineProperty(InGetAnnotations.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetAnnotations.prototype, "flow", {
        get: function () {
            return this._flow;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flow is not optional');
            }
            this._flow = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetAnnotations.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            flow: this.flow.serialize()
        };
    };
    return InGetAnnotations;
}());
var OutGetAnnotationsHelpers = (function () {
    function OutGetAnnotationsHelpers() {
    }
    OutGetAnnotationsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetAnnotationsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new octopus_notifications_1.UserAnnotations(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetAnnotationsHelpers;
}());
var InAddAnnotation = (function () {
    function InAddAnnotation(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.flow = new octopus_common_1.FlowID(data.flow);
        this.text = data.text;
    }
    Object.defineProperty(InAddAnnotation.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddAnnotation.prototype, "flow", {
        get: function () {
            return this._flow;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field flow is not optional');
            }
            this._flow = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddAnnotation.prototype, "text", {
        get: function () {
            return this._text;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field text is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field text expects type string, got ' + value);
            }
            this._text = value;
        },
        enumerable: false,
        configurable: true
    });
    InAddAnnotation.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            flow: this.flow.serialize(),
            text: this.text
        };
    };
    return InAddAnnotation;
}());
var OutAddAnnotationHelpers = (function () {
    function OutAddAnnotationHelpers() {
    }
    OutAddAnnotationHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutAddAnnotationHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAddAnnotationHelpers;
}());
var FlowsServiceClient = (function () {
    function FlowsServiceClient(transport) {
        this._transport = transport;
    }
    FlowsServiceClient.prototype.getPackageName = function () { return FlowsServiceClient.PackageName; };
    FlowsServiceClient.prototype.getClassName = function () { return FlowsServiceClient.ClassName; };
    FlowsServiceClient.prototype.getFullClassName = function () { return FlowsServiceClient.FullClassName; };
    FlowsServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.create = function (app, data) {
        var _this = this;
        var __data = new InCreate();
        __data.app = app;
        __data.data = data;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'create', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.retrieve = function (id, version) {
        var _this = this;
        var __data = new InRetrieve();
        __data.id = id;
        __data.version = version;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'retrieve', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.update = function (id, data, version) {
        var _this = this;
        var __data = new InUpdate();
        __data.id = id;
        __data.data = data;
        __data.version = version;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'update', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.delete = function (id) {
        var _this = this;
        var __data = new InDelete();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'delete', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.queryVersions = function (id, iterator, sortBy, filterBy, features) {
        var _this = this;
        var __data = new InQueryVersions();
        __data.id = id;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.features = features;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'queryVersions', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryVersionsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.queryFlows = function (app, iterator, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryFlows();
        __data.app = app;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'queryFlows', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryFlowsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.checkFlows = function (flows) {
        var _this = this;
        var __data = new InCheckFlows();
        __data.flows = flows;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'checkFlows', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckFlowsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.queryPromotions = function (id, features) {
        var _this = this;
        var __data = new InQueryPromotions();
        __data.id = id;
        __data.features = features;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'queryPromotions', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryPromotionsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.promote = function (id, version, env, space) {
        var _this = this;
        var __data = new InPromote();
        __data.id = id;
        __data.version = version;
        __data.env = env;
        __data.space = space;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'promote', __data)
                .then(function (data) {
                try {
                    resolve(OutPromoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.demote = function (id, version, env, space) {
        var _this = this;
        var __data = new InDemote();
        __data.id = id;
        __data.version = version;
        __data.env = env;
        __data.space = space;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'demote', __data)
                .then(function (data) {
                try {
                    resolve(OutDemoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.queryPromotionsBatch = function (ids, features) {
        var _this = this;
        var __data = new InQueryPromotionsBatch();
        __data.ids = ids;
        __data.features = features;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'queryPromotionsBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryPromotionsBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.promoteBatch = function (batch, env, space) {
        var _this = this;
        var __data = new InPromoteBatch();
        __data.batch = batch;
        __data.env = env;
        __data.space = space;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'promoteBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutPromoteBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.demoteBatch = function (batch, env, space) {
        var _this = this;
        var __data = new InDemoteBatch();
        __data.batch = batch;
        __data.env = env;
        __data.space = space;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'demoteBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutDemoteBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.queryNotifications = function (appID, flow, iterator, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryNotifications();
        __data.appID = appID;
        __data.flow = flow;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'queryNotifications', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryNotificationsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.getAnnotations = function (appID, flow) {
        var _this = this;
        var __data = new InGetAnnotations();
        __data.appID = appID;
        __data.flow = flow;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'getAnnotations', __data)
                .then(function (data) {
                try {
                    resolve(OutGetAnnotationsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.prototype.addAnnotation = function (appID, flow, text) {
        var _this = this;
        var __data = new InAddAnnotation();
        __data.appID = appID;
        __data.flow = flow;
        __data.text = text;
        return new Promise(function (resolve, reject) {
            _this._transport.send(FlowsServiceClient.ClassName, 'addAnnotation', __data)
                .then(function (data) {
                try {
                    resolve(OutAddAnnotationHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    FlowsServiceClient.PackageName = 'net.playq.octopus2.liveops';
    FlowsServiceClient.ClassName = 'FlowsService';
    FlowsServiceClient.FullClassName = 'net.playq.octopus2.liveops.FlowsService';
    return FlowsServiceClient;
}());
exports.FlowsServiceClient = FlowsServiceClient;
var FlowsServiceDispatcher = (function () {
    function FlowsServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    FlowsServiceDispatcher.prototype.getSupportedService = function () {
        return 'FlowsService';
    };
    FlowsServiceDispatcher.prototype.getSupportedMethods = function () {
        return FlowsServiceDispatcher.methods;
    };
    FlowsServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "create": {
                var obj_1 = new InCreate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.create(context, obj_1.app, obj_1.data)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieve": {
                var obj_2 = new InRetrieve(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieve(context, obj_2.id, obj_2.version)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "update": {
                var obj_3 = new InUpdate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.update(context, obj_3.id, obj_3.data, obj_3.version)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "delete": {
                var obj_4 = new InDelete(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.delete(context, obj_4.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryVersions": {
                var obj_5 = new InQueryVersions(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryVersions(context, obj_5.id, obj_5.iterator, obj_5.sortBy, obj_5.filterBy, obj_5.features)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryVersionsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryFlows": {
                var obj_6 = new InQueryFlows(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryFlows(context, obj_6.app, obj_6.iterator, obj_6.sortBy, obj_6.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryFlowsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkFlows": {
                var obj_7 = new InCheckFlows(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkFlows(context, obj_7.flows)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckFlowsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryPromotions": {
                var obj_8 = new InQueryPromotions(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryPromotions(context, obj_8.id, obj_8.features)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryPromotionsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "promote": {
                var obj_9 = new InPromote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.promote(context, obj_9.id, obj_9.version, obj_9.env, obj_9.space)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPromoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "demote": {
                var obj_10 = new InDemote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.demote(context, obj_10.id, obj_10.version, obj_10.env, obj_10.space)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDemoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryPromotionsBatch": {
                var obj_11 = new InQueryPromotionsBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryPromotionsBatch(context, obj_11.ids, obj_11.features)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryPromotionsBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "promoteBatch": {
                var obj_12 = new InPromoteBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.promoteBatch(context, obj_12.batch, obj_12.env, obj_12.space)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPromoteBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "demoteBatch": {
                var obj_13 = new InDemoteBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.demoteBatch(context, obj_13.batch, obj_13.env, obj_13.space)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDemoteBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryNotifications": {
                var obj_14 = new InQueryNotifications(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryNotifications(context, obj_14.appID, obj_14.flow, obj_14.iterator, obj_14.sortBy, obj_14.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryNotificationsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getAnnotations": {
                var obj_15 = new InGetAnnotations(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getAnnotations(context, obj_15.appID, obj_15.flow)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetAnnotationsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "addAnnotation": {
                var obj_16 = new InAddAnnotation(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.addAnnotation(context, obj_16.appID, obj_16.flow, obj_16.text)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAddAnnotationHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by FlowsServiceDispatcher."));
        }
    };
    FlowsServiceDispatcher.methods = [
        "create",
        "retrieve",
        "update",
        "delete",
        "queryVersions",
        "queryFlows",
        "checkFlows",
        "queryPromotions",
        "promote",
        "demote",
        "queryPromotionsBatch",
        "promoteBatch",
        "demoteBatch",
        "queryNotifications",
        "getAnnotations",
        "addAnnotation"
    ];
    return FlowsServiceDispatcher;
}());
exports.FlowsServiceDispatcher = FlowsServiceDispatcher;
var FlowsServiceServer = (function (_super) {
    __extends(FlowsServiceServer, _super);
    function FlowsServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    FlowsServiceServer.prototype.create = function (context, app, data) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.retrieve = function (context, id, version) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.update = function (context, id, data, version) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.delete = function (context, id) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.queryVersions = function (context, id, iterator, sortBy, filterBy, features) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.queryFlows = function (context, app, iterator, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.checkFlows = function (context, flows) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.queryPromotions = function (context, id, features) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.promote = function (context, id, version, env, space) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.demote = function (context, id, version, env, space) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.queryPromotionsBatch = function (context, ids, features) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.promoteBatch = function (context, batch, env, space) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.demoteBatch = function (context, batch, env, space) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.queryNotifications = function (context, appID, flow, iterator, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.getAnnotations = function (context, appID, flow) {
        throw new Error('Not implemented.');
    };
    FlowsServiceServer.prototype.addAnnotation = function (context, appID, flow, text) {
        throw new Error('Not implemented.');
    };
    return FlowsServiceServer;
}(FlowsServiceDispatcher));
exports.FlowsServiceServer = FlowsServiceServer;
//# sourceMappingURL=FlowsService.js.map